import { render, staticRenderFns } from "./logisticsNumber.vue?vue&type=template&id=abfbf5d8"
import script from "./logisticsNumber.vue?vue&type=script&lang=js"
export * from "./logisticsNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports